// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file responses/v1/addon_usage_response.proto (package responses.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';
import type { AddonUsage } from '../../subscription/v1/addon_usage_pb';
import { file_subscription_v1_addon_usage } from '../../subscription/v1/addon_usage_pb';
import type { Message } from '@bufbuild/protobuf';

/**
 * Describes the file responses/v1/addon_usage_response.proto.
 */
export const file_responses_v1_addon_usage_response: GenFile =
    /*@__PURE__*/
    fileDesc(
        'CidyZXNwb25zZXMvdjEvYWRkb25fdXNhZ2VfcmVzcG9uc2UucHJvdG8SDHJlc3BvbnNlcy52MSJBChJBZGRvblVzYWdlUmVzcG9uc2USKwoGYWRkb25zGAEgAygLMhsuc3Vic2NyaXB0aW9uLnYxLkFkZG9uVXNhZ2VCggEKEGNvbS5yZXNwb25zZXMudjFCF0FkZG9uVXNhZ2VSZXNwb25zZVByb3RvUAFaBC4vcGKiAgNSWFiqAgxSZXNwb25zZXMuVjHKAgxSZXNwb25zZXNcVjHiAhhSZXNwb25zZXNcVjFcR1BCTWV0YWRhdGHqAg1SZXNwb25zZXM6OlYxYgZwcm90bzM',
        [file_subscription_v1_addon_usage]
    );

/**
 * @generated from message responses.v1.AddonUsageResponse
 */
export type AddonUsageResponse = Message<'responses.v1.AddonUsageResponse'> & {
    /**
     * @generated from field: repeated subscription.v1.AddonUsage addons = 1;
     */
    addons: AddonUsage[];
};

/**
 * Describes the message responses.v1.AddonUsageResponse.
 * Use `create(AddonUsageResponseSchema)` to create a new message.
 */
export const AddonUsageResponseSchema: GenMessage<AddonUsageResponse> =
    /*@__PURE__*/
    messageDesc(file_responses_v1_addon_usage_response, 0);
